/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/MoveToAnotherTreatment/Events/Content/Event/Appointment/Content/Hour/Content"
  
}) {
let appointmentBookingLocalStartDateValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.local_start_date',
})
let appointmentBookingLocalStartTimeValueData = fromData.useDataValue({ viewPath,
context: 'appointment',
path: 'booking.local_start_time',
})
let aggregateData = fromHelpers.formatHour(appointmentBookingLocalStartDateValueData, appointmentBookingLocalStartTimeValueData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="regular"
 color={dtColorsNeutral700}
 data="appointment.booking.local_start_date"
 data="appointment.booking.local_start_time"
 aggregate="helpers.js formatHour"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}